<template>
  <div class="inboundScanning">
    <!-- 出库扫码 -->
    <div style="display: flex; align-items: center">
      <van-button
        type="info"
        size="small"
        style="display: flex"
        :text="ray"
        @click="holdRay()"
      ></van-button>
      <div>
        <input
          id="scanQRCode"
          @keyup.enter="add_mx()"
          ref="getIDInpot"
          v-model="add_data"
          v-on:blur="hideMessage()"
          readonly
          style="height: 20px; width: 100px"
          autocomplete="off"
        />
      </div>
      <van-button
        size="small"
        type="primary"
        @click="outAll()"
      >
        全部入箱
      </van-button>
    </div>
    <div style="display: flex; flex-wrap: wrap">
      <van-button
        v-for="(item, index) in mxList"
        :key="index"
        type="default"
        size="small"
        @click="dleClick(index)"
      >
        {{ item }}
        &nbsp; &nbsp; &nbsp;
        <van-icon name="cross" />
      </van-button>
    </div>
    <div class="filling-goods-bottom">
      <van-button type="warning" class="bottom-button" @click="go_index()"
        >回首页</van-button
      >
      <van-button
        type="info"
        class="bottom-button"
        @click="queryOrderQuantity()"
      >
        查看近期箱子动态
      </van-button>
      <van-button type="primary" class="bottom-button" @click="pickup()">
        车取货
      </van-button>
    </div>

    <van-popup v-model="show" position="bottom">
      <table class="pure-table pure-table-bordered">
        <thead>
          <th>箱号</th>
          <th>状态</th>
        </thead>

        <tbody>
          <tr v-for="(packdata, index) in packingData" :key="index">
            <td>{{ packdata.number }}</td>
            <td>{{ packdata.status }}</td>
          </tr>
        </tbody>
      </table>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  name: "InboundScanning",
  data() {
    return {
      ray: "已暂停，点击我继续扫码",
      add_data: "",
      packingData: [],
      show: false,
      mx: "",
      count: 0, // 记录请求的次数
      mxList: [],
    };
  },
  methods: {
    async outAll(){
      let pack_num = this.mxList.join(',')
      let packdata = await this.get(this.APIOBJ.inPack , {pack_num})
      if(packdata.data.status === 1){
        Toast(packdata.data.msg)
        this.mxList = []
      }else{
        Toast(packdata.data.msg)
      }
    },
    holdRay() {
      this.ray = "扫描中";
      this.focus();
    },
    dleClick(index) {
      Dialog({
        message: `确定要删除${this.mxList[index]}单号吗`,
      }).then(() => {
        this.mxList.splice(index , 1);
      });
    },
    async add_mx() {
      if (this.mxList.indexOf(this.add_data) === -1) {
        this.mxList.push(this.add_data);
      } else {
        Toast("该明细码已经添加");
      }
      this.add_data = ""
    },
    hideMessage() {
      this.ray = "已暂停，点击我继续扫码";
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗?",
      }).then(() => {
        this.$router.push("/home");
      });
    },
    async queryOrderQuantity() {
      // 查询近期箱子动态
      let packing = await this.get(this.APIOBJ.packitem);
      this.packingData = packing.data.data;
      this.show = true;
    },
    async pickup() {
      // 取货
      if (this.count === 0) {
        let packing = await this.get(this.APIOBJ.carPlay);
        if (packing.status === 200) {
          Toast(packing.data.data.code + "成功");
        }
        setTimeout(() => {
          this.count = 0;
        }, 2000);
      } else {
        Dialog.confirm({
          message: "您确定连续放货吗，注意安全",
        }).then(async () => {
          let packing = await this.get(this.APIOBJ.carPlay);
          if (packing.status === 200) {
            Toast(packing.data.data.code + "成功");
          }
        });
      }

      this.count++;
    },
  },
};
</script>

<style>
.filling-goods-bottom {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
}

td,
th {
  padding: 0;
}
.pure-table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #cbcbcb;
}

.pure-table caption {
  color: #000;
  font: italic 85%/1 arial, sans-serif;
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  padding: 0.5em 1em;
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  text-align: left;
  vertical-align: bottom;
}

.pure-table td {
  background-color: transparent;
}

.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}
</style>